import { Slider } from "primereact/slider";
import { useState, useEffect } from "react";
import PropTypes from "prop-types";

const GoldWtRangeFilter = ({
    title,
    min,
    max,
    step,
    values,
    onChange,
    mintext,
    maxtext,
    previcon,
    pasticon,
    inputID,
    hideText
}) => {
    const [validValues, setValidValues] = useState(values);
    const safePastIcon = pasticon ?? "";

    useEffect(() => {
        const validateAndSortValues = (vals) => {
            const validated = vals.map((value) => {
                let validValue = Math.max(min, Math.min(max, value));
                validValue = Math.round(validValue / step) * step;
                return validValue;
            });
            return validated.sort((a, b) => a - b);
        };

        const newValidValues = validateAndSortValues(values);
        setValidValues(newValidValues);

        if (JSON.stringify(newValidValues) !== JSON.stringify(values)) {
            onChange(newValidValues);
        }
    }, [min, max, step, values, onChange]);

    const handleChange = (e) => {
        let newValues = e.value;

        const validatedValues = newValues.map((value) => {
            let validValue = Math.max(min, Math.min(max, value));
            validValue = Math.round(validValue / step) * step;
            return validValue;
        });

        const sortedValues = validatedValues.sort((a, b) => a - b);

        setValidValues(sortedValues);
        onChange(sortedValues);
    };

    return (
        <div className="diamond_filter_section">
            <div className="filter_range_slider">
                <div className="diamond_filter_text">
                    <p>{title}</p>
                </div>

                {!hideText && (
                    <div className="range_value_container">
                        <p className="range_value">
                            <input
                                type="text"
                                id={inputID}
                                value={`${validValues[0]} GM - ${validValues[1]}${safePastIcon} GM`}
                                readOnly
                            />
                        </p>
                    </div>
                )}

                <div className="range_bar_container">
                    {!hideText && mintext && (
                        <div className="range_value_text max_value">
                            <span>{mintext}</span>
                        </div>
                    )}
 
                    <Slider
                        value={validValues}
                        onChange={handleChange}
                        range
                        min={min}
                        max={max}
                        step={step}
                        className="w-full"
                    />
 
                    {!hideText && maxtext && (
                        <div className="range_value_text max_value">
                            <span>{maxtext}</span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default GoldWtRangeFilter;